// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"6db94b10","66":"43b6029e","488":"2c349f10","557":"af8178e8","708":"7318ff89","845":"95f3bf49","892":"88710ca9","903":"5a61f3f8","965":"7b2df41e"}[chunkId] + ".chunk.js";
};